/**
 * Pricing Configuration for Visual Atmos
 *
 * Edit this file to update pricing across the entire app.
 * After editing, restart the frontend for changes to take effect.
 */

export const PRICING_CONFIG = {
  plans: [
    {
      id: 'starter',
      name: 'Starter',
      price: 12,
      period: 'Month',
      credits: 1250,
      popular: false,
      tagline: 'Everything you need to create relaxing cozy ambiance loops.',
      bonus: '20% Better Value!',
      features: [
        '1,250 Credits',
        'Access to all features & resolutions',
        'Free Video Looping',
        '2 Simultaneous Generations',
        'Standard Processing Queue',
        'Commercial Usage License'
      ]
    },
    {
      id: 'plus',
      name: 'Plus',
      price: 25,
      period: 'Month',
      credits: 2700,
      popular: true,
      tagline: 'More credits at a better rate, designed for consistent creators.',
      bonus: '24% Better Value!',
      features: [
        '2,700 Credits',
        'Access to all features & resolutions',
        'Free Video Looping',
        '3 Simultaneous Generations',
        'Standard Processing Queue',
        'Commercial Usage License'
      ]
    },
    {
      id: 'pro',
      name: 'Pro',
      price: 50,
      period: 'Month',
      credits: 5600,
      popular: false,
      tagline: 'Maximum value and speed for YouTube channel owners.',
      bonus: '29% Better Value!',
      features: [
        '5,600 Credits',
        'Access to all features & resolutions',
        'Free Video Looping',
        '5 Simultaneous Generations',
        'Priority Processing Queue',
        'Commercial Usage License'
      ]
    }
  ],

  settings: {
    creditsPerGeneration: 150,
    videoStorageDays: 7,
    currency: 'usd',
    currencySymbol: '$'
  },

  topups: [
    {
      id: 'quick_refill',
      name: 'Quick Refill',
      price: 3,
      credits: 260,
      tagline: 'A quick boost for your next render.',
      features: [
        '260 Credits',
        'Access to all features & resolutions',
        'Free Video Looping',
        '1 Simultaneous Generation',
        'Standard Processing Queue',
        'Commercial Usage License'
      ]
    },
    {
      id: 'project_pack',
      name: 'Project Pack',
      price: 9,
      credits: 800,
      bonus: '2% Better Value!',
      tagline: 'Enough for a full project session.',
      features: [
        '800 Credits',
        'Access to all features & resolutions',
        'Free Video Looping',
        '1 Simultaneous Generation',
        'Standard Processing Queue',
        'Commercial Usage License'
      ]
    },
    {
      id: 'bulk_pack',
      name: 'Bulk Pack',
      price: 15,
      credits: 1500,
      popular: true,
      bonus: '15% Better Value!',
      tagline: 'Maximum value for regular creators.',
      features: [
        '1,500 Credits',
        'Access to all features & resolutions',
        'Free Video Looping',
        '1 Simultaneous Generation',
        'Standard Processing Queue',
        'Commercial Usage License'
      ]
    },
    {
      id: 'studio_pack',
      name: 'Studio Pack',
      price: 45,
      credits: 4750,
      bonus: '21% Better Value!',
      tagline: 'For studios and heavy users.',
      features: [
        '4,750 Credits',
        'Access to all features & resolutions',
        'Free Video Looping',
        '1 Simultaneous Generation',
        'Standard Processing Queue',
        'Commercial Usage License'
      ]
    }
  ]
};

// Helper function to calculate price per credit
export const getPricePerCredit = (plan) => {
  return (plan.price / plan.credits).toFixed(3);
};

// Helper to get video count
export const getVideoCount = (plan) => {
  return Math.floor(plan.credits / PRICING_CONFIG.settings.creditsPerGeneration);
};
